import React from 'react';
import { userReferralsUrl } from 'buyside/util/urlHelper';

const InviteNewMembersSubmitted = () => {
  return (
    <div>
      <h4>Referrals Sent</h4>
      <p>
        Get your personal referral link and track your referrals in
        <strong>
          <a href={userReferralsUrl()}> your account settings</a>
        </strong>{' '}
        .
      </p>
    </div>
  );
};

export default InviteNewMembersSubmitted;
